// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"ce98bf6e","265":"8050687a","787":"0d66e12a"}[chunkId] + ".chunk.js";
};